import AppLayout from '../layouts/AppLayout'
import React, { Fragment, useEffect, useState, useContext, useMemo } from 'react'
import { AppContext } from '../contexts/AppContext'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Transition, Listbox } from '@headlessui/react'
import Spinner from 'react-activity/dist/Spinner'
import 'react-activity/dist/Spinner.css'
import { RxChevronDown } from 'react-icons/rx'
import { HiArrowNarrowRight } from 'react-icons/hi'
import { getCompetitionImage } from '../utils/competition'

const EditTeam = () => {
  const { teamId } = useParams()
  const navigate = useNavigate()
  const { getCompetitions, getteam, updateTeam, isLoading } = useContext(AppContext)

  const [name, setName] = useState('')
  const [status, setStatus] = useState('Active')
  const [competitions, setCompetitions] = useState([])
  const [competition, setCompetition] = useState(null)
  const [file, setFile] = useState(null)
  const [filePreviewURL, setFilePreviewURL] = useState('')

  const filePreview = useMemo(() => {
    if (!file) return null
    setFilePreviewURL(URL.createObjectURL(file))
    return filePreviewURL
  }, [file])

  useEffect(() => {
    const init = async () => {
      const comps = await getCompetitions()
      setCompetitions(comps)
      const teamRes = await getteam(teamId)
      if (teamRes && teamRes[0]) {
        const t = teamRes[0]
        setName(t.name)
        setStatus(t.status)
        setCompetition(t.competition)
      }
    }
    init()
  }, [teamId])

  const selectedCompetitionTitle = useMemo(() => {
    if (!competition || !competitions.length) return 'no competition selected'
    const div = competitions.find((d) => d.id === competition)
    return div?.name
  }, [competition, competitions])

  const handleFileUpload = (event) => {
    const [uploadedFile] = event.target.files
    setFile(uploadedFile)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name || !competition) return
    const res = await updateTeam({ id: teamId, name, status, competition, file })
    if (res === 'success') navigate('/teams')
  }

  return (
    <AppLayout pageName={'Edit Team'}>
      <section>
        <form onSubmit={handleSubmit} method='post' encType='multipart/form-data' className={`grid grid-cols-1 sm:grid-cols-2 gap-4`}>
          <div className='mb-2'>
            <div className='p-2'>
              <label htmlFor='name'>Team Logo</label>
              <input id='logo' name='logo' type='file' className='form-control' onChange={handleFileUpload} />
              {filePreview && (
                <div className='w-[200px] h-[auto] relative mt-2'>
                  <img src={filePreview} className='rounded-xl' alt='' />
                </div>
              )}
            </div>
            <div className='p-2'>
              <label htmlFor='name'>Team Name</label>
              <input id='name' name='name' required type='text' className='form-control' value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div className='p-2'>
              <Listbox value={competition} onChange={setCompetition}>
                <Listbox.Label>Competition</Listbox.Label>
                <div className='relative mt-1'>
                  <Listbox.Button className='form-control relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left'>
                    <span className='block truncate'>{selectedCompetitionTitle}</span>
                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                      <RxChevronDown className='h-5 w-5 text-gray-400' aria-hidden='true' />
                    </span>
                  </Listbox.Button>
                  <Transition as={Fragment} leave='transition ease-in duration-100' leaveFrom='opacity-100' leaveTo='opacity-0'>
                    <Listbox.Options className='absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10'>
                      {competitions.map((comp) => (
                        <Listbox.Option key={comp.id} className={({ active }) => `relative cursor-default select-none py-2 px-4 ${active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'}`} value={comp.id}>
                          <div className='flex justify-start gap-4 text-base font-medium items-center text-neutral-800'>
                            {comp.logo && <img width='30' height='30' src={getCompetitionImage(comp.logo)} alt={comp.name} className='rounded border-2 border-neutral-100' />}
                            {comp.name}
                          </div>
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </Listbox>
            </div>

            <div className='p-2'>
              <Listbox value={status} onChange={setStatus}>
                <Listbox.Label>Status</Listbox.Label>
                <div className='relative mt-1'>
                  <Listbox.Button className='form-control relative w-full cursor-default rounded-lg bg-white py-2 pl-3 pr-10 text-left'>
                    <span className='block truncate'>{status}</span>
                    <span className='pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2'>
                      <RxChevronDown className='h-5 w-5 text-gray-400' aria-hidden='true' />
                    </span>
                  </Listbox.Button>
                  <Transition as={Fragment} leave='transition ease-in duration-100' leaveFrom='opacity-100' leaveTo='opacity-0'>
                    <Listbox.Options className='absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-none sm:text-sm z-10'>
                      {['Active', 'Inactive'].map((s) => (
                        <Listbox.Option key={s} className={({ active }) => `relative cursor-default select-none py-2 pl-10 pr-4 ${active ? 'bg-amber-100 text-amber-900' : 'text-gray-900'}`} value={s}>
                          {s}
                        </Listbox.Option>
                      ))}
                    </Listbox.Options>
                  </Transition>
                </div>
              </Listbox>
            </div>

            <div className='px-2'>
              <div className='flex space-x-3'>
                <button type='submit' className='btn-submit' disabled={isLoading}>
                  <span>Save Changes</span>
                  <span>
                    {isLoading === false ? (
                      <HiArrowNarrowRight />
                    ) : (
                      <Spinner size={14} className='ml-2' animating={isLoading} />
                    )}
                  </span>
                </button>
                <Link to={'/teams'} className='btn-cancel' disabled={isLoading}>
                  <span>Cancel</span>
                </Link>
              </div>
            </div>
          </div>
        </form>
      </section>
    </AppLayout>
  )
}

export default EditTeam
